export const TITLE = 'NextAuth';
export const COLOR_PRIMARY = '#000';
